import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LoadingSpinner, Stack } from '@adc/parallax-component-library';
import { useApiError, useConnection } from 'Hooks';
import { LogoActionBar, Main, ScrollContainer } from 'Components/utility';
import { InAppActionBar } from 'Components/utility/ActionBar/InAppActionBar';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import CaregiverCard from '../Caregiver/CaregiverCard';
import LibreDataShareCard from '../LibreDataShare/LibreDataShareCard';
import PartnerCard from '../Partner/PartnerCard';
import PracticeCard from '../Practice/PracticeCard';
const mapStateToProps = ({ env: { app } }) => {
    return {
        isLibre: app === 'libre1',
    };
};
const connector = connect(mapStateToProps);
const MainConnection = ({ isLibre }) => {
    const { getConnections } = useConnection();
    const { showApiErrorModal } = useApiError();
    const [loading, setLoading] = useState(true);
    const [connections, setConnections] = useState();
    useEffect(() => {
        const loadConnections = async () => {
            try {
                setLoading(true);
                const connections = await getConnections();
                setConnections(connections);
            }
            catch {
                showApiErrorModal();
            }
            finally {
                setLoading(false);
            }
        };
        loadConnections();
    }, [getConnections, showApiErrorModal]);
    return (React.createElement(Main, null,
        isLibre ? (React.createElement(InAppActionBar, { onBack: () => notifyApp('adc-webview:navigate-back-app'), closeBtn: true, title: i18n.t('Connections.title'), testID: "Connections" })) : (React.createElement(LogoActionBar, { testID: "Connections" })),
        loading ? (React.createElement(Stack, { width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flex: 1 },
            React.createElement(LoadingSpinner, { testID: "LibreLinkUp.spinner" }))) : (React.createElement(ScrollContainer, { marginTop: isLibre ? 0 : 115 },
            React.createElement(Stack, { padding: "$4" },
                isLibre && (React.createElement(PracticeCard, { practiceConnections: connections?.practiceConnections, practiceInvitations: connections?.practiceInvitations })),
                React.createElement(CaregiverCard, { caregiverInvitations: connections?.caregiverInvitations, caregiverConnections: connections?.caregiverConnections, isLibre: isLibre }),
                isLibre && React.createElement(LibreDataShareCard, { dataShareConnection: connections?.libreDataShare }),
                React.createElement(PartnerCard, { partnerConnections: connections?.partnerConnections, partnerInvitations: connections?.partnerInvitations, availableCommercialApiPartners: connections?.availableCommercialAPIPartners }))))));
};
export default connector(MainConnection);
